<app-base-pesquisa #modal titulo="Pesquisa Natureza de Exames" subtitulo="Clique duas vezes em cima da linha do registro para realizar a seleção." 
    (registroSelecionado)="selecionado($event)">
    <ng-template appFiltroPesquisa>
        <div class='form-group' >
            <ejs-checkbox [label]="'Apenas exames mapeados com o eSocial'" 
            [(checked)]="apenasEsocial"></ejs-checkbox>
        </div>
        <div class="form-group">
            <input type="button" ejs-button iconCss="fas fa-search" value="Atualizar" (click)="atualizar()" cssClass="e-primary btn-block"/>
        </div>
    </ng-template>
    <ng-template appConteudoPesquisa>
        <ejs-grid #grid appGridPesquisa
            [dataSource]="registros"
            [enableVirtualization]='false' 
            [pageSettings]='{ pageSize: 100 }'
            height='100%' 
            [toolbar]="toolbarItens"
            [selectionSettings]="{enableToggle: false}"
            [allowFiltering]='false' 
            [allowSorting]='true' 
            [allowResizing]='true' 

            [showColumnChooser]='false'
            [showColumnMenu]='false'
           
            [allowExcelExport]='false'
            [allowPdfExport]='false'
            [allowPdfExport]='false'>
            <e-columns>
                <e-column field='id' [headerText]="'Id'" [visible]="false" [isPrimaryKey]="true"></e-column>
                <e-column field='natureza' [headerText]="'Natureza'"></e-column>
                <e-column field='esocial' [headerText]="'eSocial'"></e-column>
            </e-columns>

            <e-aggregates>
                <e-aggregate>
                    <e-columns>
                        <e-column field="id" type="count">
                            <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                        </e-column>
                    </e-columns>
                </e-aggregate>
            </e-aggregates>

        </ejs-grid>
    </ng-template>
</app-base-pesquisa>
